import { useEffect, useRef, useState } from "react"
import { Loader2 } from "lucide-react"

interface MapLoadingIndicatorProps {
  isLoading: boolean
  message: string
}

export const MapLoadingIndicator = ({ isLoading, message }: MapLoadingIndicatorProps) => {
  const [visible, setVisible] = useState(false)
  const lastMessageRef = useRef(message)

  if (message) lastMessageRef.current = message

  useEffect(() => {
    if (isLoading) {
      setVisible(true)
    } else {
      const timer = setTimeout(() => setVisible(false), 200)
      return () => clearTimeout(timer)
    }
  }, [isLoading])

  if (!visible) return null

  return (
    <>
      {/* Top-edge progress bar */}
      <div
        className={`loading-bar-track ${isLoading ? "loading-bar-active" : "loading-bar-done"}`}
        role="status"
        aria-live="polite"
      >
        <div className="loading-bar-fill" />
      </div>

      {/* Floating pill */}
      <div
        className="absolute top-28 left-1/2 -translate-x-1/2 z-20 transition-opacity duration-200"
        style={{ opacity: isLoading ? 1 : 0 }}
      >
        <div className="bg-white/95 backdrop-blur-sm rounded-xl map-panel-shadow px-4 py-2 flex items-center gap-2">
          <Loader2 className="w-4 h-4 text-primary animate-spin" />
          <span className="text-sm text-gray-600 font-medium">{message || lastMessageRef.current}</span>
        </div>
      </div>
    </>
  )
}
